import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IGridCard } from '@/modules/FilterableGridModule/FilterableGridModule.types';
import Brochure from '@/components/BrochureCard/BrochureCard.vue';
import Destination from '@/components/DestinationCard/DestinationCard.vue'
import Itinerary from '@/components/ItineraryCard/ItineraryCard.vue'
import TeamMember from '@/components/TeamMemberCard/TeamMemberCard.vue'
import Ship from '@/components/ShipCard/ShipCard.vue'
import Article from '@/components/ArticleCard/ArticleCard.vue'
import Personal from '@/components/PersonalCard/PersonalCard.vue'
@Component({
  components: {
    Destination,
    Itinerary,
    TeamMember,
    Ship,
    Brochure,
    Article,
    Personal,
  },
})
export default class GenericCard extends Vue {
  @Prop()
  readonly card!: IGridCard;

  @Prop()
  readonly resetCardState!: boolean;
}
